import {takeLatest, put} from 'redux-saga/effects';
import {
  GET_PARTNER_WITH_ID_FAILED,
  GET_PARTNER_WITH_ID_SUCCESS,
  GET_PARTNER_WITH_ID,
  GET_PARTNERS_FAILED,
  GET_PARTNERS_SUCCESS,
  GET_PARTNERS,
  UPDATE_PARTNER_FAILED,
  UPDATE_PARTNER_SUCCESS,
  UPDATE_PARTNER,
  CREATE_PARTNER,
  CREATE_PARTNER_SUCCESS,
  CREATE_PARTNER_FAILED,
  UPDATE_PARTNER_STATUS_FAILED,
  UPDATE_PARTNER_STATUS_SUCCESS,
  UPDATE_PARTNER_STATUS,
  GET_USERS_BY_PARTNERID,
  GET_USERS_BY_PARTNERID_SUCCESS,
  GET_USERS_BY_PARTNERID_FAILED,
  GET_USERS_BE_ADMIN_PARTNER,
  GET_USERS_BE_ADMIN_PARTNER_SUCCESS,
  GET_USERS_BE_ADMIN_PARTNER_FAILED,
  UPDATE_PARTNER_ADMIN,
  UPDATE_PARTNER_ADMIN_SUCCESS,
  UPDATE_PARTNER_ADMIN_FAILED,
  GET_PARTNERS_INVONTORY,
  GET_PARTNERS_INVONTORY_SUCCESS,
  GET_PARTNERS_INVONTORY_FAILED,
  GET_PARTNER_CATEGORIES_SUCCESS,
  GET_PARTNER_CATEGORIES_FAILED,
  GET_PARTNER_CATEGORIES,
} from './constants';

import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';
import partnersRepository from 'client-sdk/src/Repository/partners-repository';
import usersRepository from 'client-sdk/src/Repository/users-repository';
import productRepository from 'client-sdk/src/Repository/product-repository';

//partner
export function* getPartners(actions: any): unknown {
  try {
    const {response, count} = yield partnersRepository.getPartners(actions);
    yield put({
      type: GET_PARTNERS_SUCCESS,
      data: response.data,
      count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_PARTNERS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}
//user
export function* getUsersByPartnerId(actions: any): unknown {
  try {
    const response = yield usersRepository.getUsersByPartnerId(actions);

    yield put({
      type: GET_USERS_BY_PARTNERID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_USERS_BY_PARTNERID_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}
//user
export function* getUsersBeAdminPartner(actions: any): unknown {
  try {
    const response = yield usersRepository.getUsersBeAdminPartner(actions);

    yield put({
      type: GET_USERS_BE_ADMIN_PARTNER_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_USERS_BE_ADMIN_PARTNER_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}
//partner
export function* getPartnerWithId(actions: any): unknown {
  try {
    const response = yield partnersRepository.getPartnerWithId(actions);
    yield put({
      type: GET_PARTNER_WITH_ID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_PARTNER_WITH_ID_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}
//categuries
export function* getPartnerCategories(actions: any): unknown {
  try {
    const response = yield productRepository.getPartnerCategories(actions);
    yield put({
      type: GET_PARTNER_CATEGORIES_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_PARTNER_CATEGORIES_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}
//partner
export function* updatePartner(actions: any): unknown {
  const {pagination} = actions.payload;
  try {
    yield partnersRepository.updatePartner(actions);
    yield put({
      type: UPDATE_PARTNER_SUCCESS,
    });

    yield put({
      type: GET_PARTNERS,
      payload: {...pagination},
    });

    handleNotfication('شرکت با موفقیت ویرایش شد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_PARTNER_FAILED,
      error: error.message,
    });
    handleError(error);
    handleNotfication('ویرایش  شرکت با خطا مواجه شد', 'error');
  }
}
//partner
export function* updatePartnerAdmin(actions: any): unknown {
  const {pagination} = actions.payload;
  try {
    yield partnersRepository.updatePartnerAdmin(actions);
    yield put({
      type: UPDATE_PARTNER_ADMIN_SUCCESS,
    });
    yield put({
      type: GET_USERS_BY_PARTNERID,
      payload: {...pagination},
    });
    handleNotfication('کاربر مرکز با موفقیت ویرایش شد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_PARTNER_ADMIN_FAILED,
      error: error.message,
    });
    handleError(error);
    handleNotfication('ویرایش کاربر مرکز با خطا مواجه شد', 'error');
  }
}
//partner
export function* createPartner(actions: any): unknown {
  const {pagination} = actions.payload;
  try {
    yield partnersRepository.createPartner(actions);
    yield put({
      type: CREATE_PARTNER_SUCCESS,
    });
    yield put({
      type: GET_PARTNERS,
      payload: {...pagination},
    });

    handleNotfication('شرکت با موفقیت اضافه شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_PARTNER_FAILED,
      error: error.message,
    });
    handleNotfication('اضافه کردن شرکت با خطا مواجه شد', 'error');
    handleError(error);
  }
}
//partner
export function* updatePartnerStatus(actions: any): unknown {
  const {pagination} = actions.payload;
  try {
    yield partnersRepository.updatePartnerStatus(actions);
    yield put({
      type: UPDATE_PARTNER_STATUS_SUCCESS,
    });
    yield put({
      type: GET_PARTNERS,
      payload: {...pagination, sort: 'created,desc'},
    });
  } catch (error) {
    yield put({
      type: UPDATE_PARTNER_STATUS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}
//partner
export function* getParentsInventory(actions: any): unknown {
  try {
    const response = yield partnersRepository.getParentsInventory(actions);
    yield put({
      type: GET_PARTNERS_INVONTORY_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_PARTNERS_INVONTORY_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export default function* partnerSaga() {
  yield takeLatest(GET_PARTNERS, getPartners);
  yield takeLatest(GET_PARTNER_WITH_ID, getPartnerWithId);
  yield takeLatest(UPDATE_PARTNER, updatePartner);
  yield takeLatest(CREATE_PARTNER, createPartner);
  yield takeLatest(UPDATE_PARTNER_STATUS, updatePartnerStatus);
  yield takeLatest(GET_USERS_BY_PARTNERID, getUsersByPartnerId);
  yield takeLatest(GET_USERS_BE_ADMIN_PARTNER, getUsersBeAdminPartner);
  yield takeLatest(UPDATE_PARTNER_ADMIN, updatePartnerAdmin);
  yield takeLatest(GET_PARTNERS_INVONTORY, getParentsInventory);
  yield takeLatest(GET_PARTNER_CATEGORIES, getPartnerCategories);
}
